import '../../Dashboard/Dashboard.sass'

import { Params, SortBy } from 'constants/misc'
import { Stack, Typography } from '@mui/material'

import { FC } from 'react'
import { FilterTab } from 'components/common/FilterTab'
import { GRAY_700 } from 'constants/styling/theme'
import { OrderListFilters } from 'dataQueries'
import SortTwoTone from '@mui/icons-material/SortTwoTone'
import { useBkbnSearchParams } from 'utils/hooks/useBkbnSearchParams'
import { useTranslation } from 'react-i18next'

/**
 * @interface Props Input properties
 */
interface Props {
  /** Current order list filters */
  filters: OrderListFilters
}

/**
 * @component Dashboard assignment sort by filters
 * @example <AssignmentSortByFilters />
 * */
export const AssignmentSortByFilters: FC<Props> = ({ filters }) => {
  const { t } = useTranslation(['dashboard'])
  const params = useBkbnSearchParams()

  return (
    <Stack>

      <Typography variant="text-sm" fontWeight={600} color={GRAY_700} height="2rem">{t('sort_by')}</Typography>

      <Stack flexDirection="column" gap="1rem" justifyContent="flex-start" margin=".8rem 0 2.4rem 0">

        <FilterTab
          isActive={filters.sortBy === SortBy.DEFAULT}
          label={t('order_id')}
          icon={<SortTwoTone fontSize='inherit' />}
          onClick={() => {
            params.set([Params.SORT_BY, SortBy.DEFAULT])
          }}
        />

        <FilterTab
          isActive={filters.sortBy === SortBy.CREATION_DATE}
          label={t('creation_date')}
          icon={<SortTwoTone fontSize='inherit' />}
          onClick={() => {
            params.set([Params.SORT_BY, SortBy.CREATION_DATE])
          }}
        />

        <FilterTab
          isActive={filters.sortBy === SortBy.SHOOTING_DATE}
          label={t('shooting_date')}
          icon={<SortTwoTone fontSize='inherit' />}
          onClick={() => {
            params.set([Params.SORT_BY, SortBy.SHOOTING_DATE])
          }}
        />

      </Stack>
    </Stack>
  )
}
